/*  MUI  */
import { Card, CardContent, CardHeader } from '@mui/material';

/*  React  */
import React from 'react';

export const DataCard = ({ children, minHeight = '250px', title }) => (
    <Card
        variant="outlined"
        data-testid="dataCard"
        style={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            minHeight
        }}
    >
        <CardHeader title={title} data-testid="dataCardCardHeader" />
        <CardContent
            data-testid="dataCardCardContent"
            style={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                justifyContent: 'center',
                paddingTop: 0
            }}
        >
            {children}
        </CardContent>
    </Card>
);
